import { createFeatureSelector, createSelector } from "@ngrx/store";
import { IProfileState } from "../../models/state/profile/profile-state";

const selectProfileState = createFeatureSelector<IProfileState>('profileState');

export namespace profileSelectors {
  export const selectLanguage = createSelector(
    selectProfileState,
    profileState => {
      return profileState.language;
    }
  );
  export const selectProfile = createSelector(
    selectProfileState,
    profileState => {
      return profileState;
    }
  );
}